export enum OrderStatus {
  NEW = 'New',
  PENDING = 'Pending Approval',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  PAYMENT_COMPLETED = 'Payment Completed',
  PAYMENT_PENDING = 'Payment Pending',
  COMPLETED = 'Completed',
}
